// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  font-family: Arial, sans-serif;
  padding: 20px;
  background-color: #f4f7f9; /* Light background color */
  min-width: 250px;
  min-height: 95.5vh;
  overflow:auto;
}

.body {
  background-color: #f4f7f9;
}

.app-header {
  text-align: center;
  margin-bottom: 20px;
  color: #034f84; /* Dark blue color */
}


.modal button.cancel-button {
  background-color: #02669b; /* Darker blue */
}

.modal button.cancel-button:hover {
  background-color: #024f78; /* Even darker blue on hover */
}


.thank-you-message {
  position:fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #28a745;
  color: white;
  padding: 20px;
  border-radius: 5px;
  z-index: 1001;
  opacity: 1;
  transition: opacity 0.5s ease;
  animation: thank-you-fadeIn 0.5s ease-in-out;
  
  pointer-events: none; /* Ensures message doesn't block clicks when invisible */
}






@keyframes thank-you-fadeIn {
  from {
    top: 0px;
    opacity: 0;
    
    
  }
  to {
    top: 20px;
    opacity: 1;
    
    
  }
}

@keyframes modalFadeIn {
  from {
    top: 60%;
    opacity: 0;
    
    
  }
  to {
    top: 50%;
    opacity: 1;
    
    
  }
}



/*.ski-area-select select {
  padding: 15px;
  font-size: 18px;
  background-color: #fff;
  border: 1px solid #034f84; 
  border-radius: 4px;
  cursor: pointer;
}


.ski-area-select-selected:after {
  position: absolute;
  content: "";
  top: 14px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #fff transparent transparent transparent;
}


.ski-area-select-selected{
  background-color: DodgerBlue;
}

.ski-area-select option {
  padding: 10px;
  font-size: 16px;
  background-color: #ffffff;
}
*/

.ski-area-header {
  text-align: center;
  margin-top: 10px;
  padding-top: 20px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0px;
  color: #034f84; 
  background-color: #b1d2eb;
  max-width: 700px;
  
  
}

.lift-list {
  display:flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  white-space: nowrap;
  overflow: auto;
  width: auto;
  min-width: 450px;
}

.lift-item {
  width: 100%;
  max-width: 700px;
  
  margin: 0px auto;
  padding: 0px;
  border: 0px solid #ddd;
  border-radius: 0px;
  text-align: left;
  background-color: #b1d2eb;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  display: inline-block;
  white-space: nowrap;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */
  /* transition: box-shadow 0.3s ease; */
}
/* .lift-item:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); 
} */

.modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  
  background-color: white;
  padding: 10px;
  border: 1px solid #ddd;
  text-align: center;
  animation: modalFadeIn 0.3s ease-in-out;
  opacity: 0; /* Start with the modal transparent */
  
  pointer-events: none; /* Prevent mouse events when modal is not visible */
  max-width: 90%; /* Maximum width of the modal relative to the screen size */
  max-height: 90%; /* Maximum height of the modal relative to the screen size */
  overflow-y: auto; /* Enable scrolling for overflow content */
}

/* The .modal-open class is applied when the modal should be visible */
.modal-open {
  opacity: 1; /* Make the modal fully visible */
  pointer-events: auto; /* Allow mouse events */
  
}


.dropdown{
  
  font-size: 16px; /* Prevent iOS zoom */
  -webkit-text-size-adjust: 100%; 
  max-width: 350px;
  margin: auto;
}

.clear-button {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 0;
  margin: 0;
}

.lift-item p {
  font-size: 20px;
  font-weight: bold;
  margin: 5px;
  padding-left: 15px;
}



.lift-item button {
  margin-top: 0px;
  padding: 5px 5px;
  margin-right: 15px;
  font-size: 15px;
  cursor: pointer;
  background-color: #2c8dc1;
  color: white;
  border: none;
  border-radius: 4px;
  transition: background-color 0.3s;
  float:right;
  
  white-space: nowrap;
  
}

.lift-item button:hover {
  background-color: #02669b; /* Darker blue on hover */
}


.modal-header {
  margin-bottom: 20px;
  text-align: center;
  color: #034f84; /* Dark blue color */
}

.modal button {
  padding: 15px 25px;
  margin: 5px;
  font-size: 16px;
  cursor: pointer;
  background-color: #0288d1; /* Lighter blue */
  color: white;
  border: none;
  border-radius: 4px;
  transition: background-color 0.3s;
}


@media (max-width: 768px) {
  .modal button {
    padding: 12px 20px;
    font-size: 15px;
    margin: 4px;
  }

  .modal {
    padding: 15px;
  }

  .modal-header {
    font-size: 18px;
  }
}

/* 
@media (max-width: 600px) {
  .modal button {
    padding: 5px 10px;
    font-size: 20px;
    margin: 3px;
  }

  .modal {
    padding: 10px;
    min-width: 300px;
  }

  .modal-header {
    font-size: 20px;
  }
.lift-list {
  min-width: 200px;
}
  .lift-item {
    margin-left: auto;
  margin-right: auto;
  }
  .lift-item p {
    font-size: 20px;
  }

  .thank-you-message {
    min-width: 200px;
    text-align: center;
  }
  
  }
Make buttons smaller on mobile screens */



  @media (max-width: 500px) {
    .modal button {
      padding: 5px 10px;
      font-size: 20px;
      margin: 3px;
    }
  
    .modal {
      padding: 10px;
      min-width: 300px;
    }
  
    .modal-header {
      font-size: 20px;
    }
  .lift-list {
    min-width: 200px;
  }
    .lift-item {
      margin-left: auto;
    margin-right: auto;
    }
    .lift-item p {
      font-size: 17px;
    }
  
    .thank-you-message {
      min-width: 200px;
      text-align: center;
    }
    
    }

    @media (max-width: 370px) {
      .modal button {
        padding: 5px 10px;
        font-size: 20px;
        margin: 3px;
      }
    
      .modal {
        padding: 10px;
        min-width: 300px;
      }
    
      .modal-header {
        font-size: 20px;
      }
    .lift-list {
      min-width: 200px;
    }
      .lift-item {
        margin-left: auto;
      margin-right: auto;
      }
      .lift-item p {
        font-size: 13px;
      }
    
      .thank-you-message {
        min-width: 200px;
        text-align: center;
      }
      
      }
  




.modal button:hover {
  background-color: #02669b; /* Darker blue on hover */
}

/* Add more styles as needed */


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,yBAAyB,EAAE,2BAA2B;EACtD,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc,EAAE,oBAAoB;AACtC;;;AAGA;EACE,yBAAyB,EAAE,gBAAgB;AAC7C;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;;AAGA;EACE,cAAc;EACd,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,4CAA4C;;EAE5C,oBAAoB,EAAE,wDAAwD;AAChF;;;;;;;AAOA;EACE;IACE,QAAQ;IACR,UAAU;;;EAGZ;EACA;IACE,SAAS;IACT,UAAU;;;EAGZ;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;;;EAGZ;EACA;IACE,QAAQ;IACR,UAAU;;;EAGZ;AACF;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA+BC;;AAED;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;;;AAGlB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;;EAEhB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,2DAA2D;EAC3D,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;EAC9C,sCAAsC;AACxC;AACA;;GAEG;;AAEH;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;;EAEhC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,UAAU,EAAE,qCAAqC;;EAEjD,oBAAoB,EAAE,mDAAmD;EACzE,cAAc,EAAE,2DAA2D;EAC3E,eAAe,EAAE,4DAA4D;EAC7E,gBAAgB,EAAE,0CAA0C;AAC9D;;AAEA,sEAAsE;AACtE;EACE,UAAU,EAAE,iCAAiC;EAC7C,oBAAoB,EAAE,uBAAuB;;AAE/C;;;AAGA;;EAEE,eAAe,EAAE,qBAAqB;EACtC,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;;;AAIA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;;EAEX,mBAAmB;;AAErB;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;AACtD;;;AAGA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB,EAAE,iBAAiB;EAC5C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;;AAGA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;wCAiCwC;;;;EAItC;IACE;MACE,iBAAiB;MACjB,eAAe;MACf,WAAW;IACb;;IAEA;MACE,aAAa;MACb,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;EACF;IACE,gBAAgB;EAClB;IACE;MACE,iBAAiB;IACnB,kBAAkB;IAClB;IACA;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;;IAEA;MACE;QACE,iBAAiB;QACjB,eAAe;QACf,WAAW;MACb;;MAEA;QACE,aAAa;QACb,gBAAgB;MAClB;;MAEA;QACE,eAAe;MACjB;IACF;MACE,gBAAgB;IAClB;MACE;QACE,iBAAiB;MACnB,kBAAkB;MAClB;MACA;QACE,eAAe;MACjB;;MAEA;QACE,gBAAgB;QAChB,kBAAkB;MACpB;;MAEA;;;;;;AAMN;EACE,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA,8BAA8B","sourcesContent":[".app-container {\n  font-family: Arial, sans-serif;\n  padding: 20px;\n  background-color: #f4f7f9; /* Light background color */\n  min-width: 250px;\n  min-height: 95.5vh;\n  overflow:auto;\n}\n\n.body {\n  background-color: #f4f7f9;\n}\n\n.app-header {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #034f84; /* Dark blue color */\n}\n\n\n.modal button.cancel-button {\n  background-color: #02669b; /* Darker blue */\n}\n\n.modal button.cancel-button:hover {\n  background-color: #024f78; /* Even darker blue on hover */\n}\n\n\n.thank-you-message {\n  position:fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #28a745;\n  color: white;\n  padding: 20px;\n  border-radius: 5px;\n  z-index: 1001;\n  opacity: 1;\n  transition: opacity 0.5s ease;\n  animation: thank-you-fadeIn 0.5s ease-in-out;\n  \n  pointer-events: none; /* Ensures message doesn't block clicks when invisible */\n}\n\n\n\n\n\n\n@keyframes thank-you-fadeIn {\n  from {\n    top: 0px;\n    opacity: 0;\n    \n    \n  }\n  to {\n    top: 20px;\n    opacity: 1;\n    \n    \n  }\n}\n\n@keyframes modalFadeIn {\n  from {\n    top: 60%;\n    opacity: 0;\n    \n    \n  }\n  to {\n    top: 50%;\n    opacity: 1;\n    \n    \n  }\n}\n\n\n\n/*.ski-area-select select {\n  padding: 15px;\n  font-size: 18px;\n  background-color: #fff;\n  border: 1px solid #034f84; \n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n.ski-area-select-selected:after {\n  position: absolute;\n  content: \"\";\n  top: 14px;\n  right: 10px;\n  width: 0;\n  height: 0;\n  border: 6px solid transparent;\n  border-color: #fff transparent transparent transparent;\n}\n\n\n.ski-area-select-selected{\n  background-color: DodgerBlue;\n}\n\n.ski-area-select option {\n  padding: 10px;\n  font-size: 16px;\n  background-color: #ffffff;\n}\n*/\n\n.ski-area-header {\n  text-align: center;\n  margin-top: 10px;\n  padding-top: 20px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 0px;\n  color: #034f84; \n  background-color: #b1d2eb;\n  max-width: 700px;\n  \n  \n}\n\n.lift-list {\n  display:flex;\n  flex-direction: column;\n  align-items: center;\n  margin: auto;\n  white-space: nowrap;\n  overflow: auto;\n  width: auto;\n  min-width: 450px;\n}\n\n.lift-item {\n  width: 100%;\n  max-width: 700px;\n  \n  margin: 0px auto;\n  padding: 0px;\n  border: 0px solid #ddd;\n  border-radius: 0px;\n  text-align: left;\n  background-color: #b1d2eb;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  display: inline-block;\n  white-space: nowrap;\n  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */\n  /* transition: box-shadow 0.3s ease; */\n}\n/* .lift-item:hover {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); \n} */\n\n.modal {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  \n  background-color: white;\n  padding: 10px;\n  border: 1px solid #ddd;\n  text-align: center;\n  animation: modalFadeIn 0.3s ease-in-out;\n  opacity: 0; /* Start with the modal transparent */\n  \n  pointer-events: none; /* Prevent mouse events when modal is not visible */\n  max-width: 90%; /* Maximum width of the modal relative to the screen size */\n  max-height: 90%; /* Maximum height of the modal relative to the screen size */\n  overflow-y: auto; /* Enable scrolling for overflow content */\n}\n\n/* The .modal-open class is applied when the modal should be visible */\n.modal-open {\n  opacity: 1; /* Make the modal fully visible */\n  pointer-events: auto; /* Allow mouse events */\n  \n}\n\n\n.dropdown{\n  \n  font-size: 16px; /* Prevent iOS zoom */\n  -webkit-text-size-adjust: 100%; \n  max-width: 350px;\n  margin: auto;\n}\n\n.clear-button {\n  position: absolute;\n  right: 5px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  padding: 0;\n  margin: 0;\n}\n\n.lift-item p {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 5px;\n  padding-left: 15px;\n}\n\n\n\n.lift-item button {\n  margin-top: 0px;\n  padding: 5px 5px;\n  margin-right: 15px;\n  font-size: 15px;\n  cursor: pointer;\n  background-color: #2c8dc1;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n  float:right;\n  \n  white-space: nowrap;\n  \n}\n\n.lift-item button:hover {\n  background-color: #02669b; /* Darker blue on hover */\n}\n\n\n.modal-header {\n  margin-bottom: 20px;\n  text-align: center;\n  color: #034f84; /* Dark blue color */\n}\n\n.modal button {\n  padding: 15px 25px;\n  margin: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  background-color: #0288d1; /* Lighter blue */\n  color: white;\n  border: none;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n\n\n@media (max-width: 768px) {\n  .modal button {\n    padding: 12px 20px;\n    font-size: 15px;\n    margin: 4px;\n  }\n\n  .modal {\n    padding: 15px;\n  }\n\n  .modal-header {\n    font-size: 18px;\n  }\n}\n\n/* \n@media (max-width: 600px) {\n  .modal button {\n    padding: 5px 10px;\n    font-size: 20px;\n    margin: 3px;\n  }\n\n  .modal {\n    padding: 10px;\n    min-width: 300px;\n  }\n\n  .modal-header {\n    font-size: 20px;\n  }\n.lift-list {\n  min-width: 200px;\n}\n  .lift-item {\n    margin-left: auto;\n  margin-right: auto;\n  }\n  .lift-item p {\n    font-size: 20px;\n  }\n\n  .thank-you-message {\n    min-width: 200px;\n    text-align: center;\n  }\n  \n  }\nMake buttons smaller on mobile screens */\n\n\n\n  @media (max-width: 500px) {\n    .modal button {\n      padding: 5px 10px;\n      font-size: 20px;\n      margin: 3px;\n    }\n  \n    .modal {\n      padding: 10px;\n      min-width: 300px;\n    }\n  \n    .modal-header {\n      font-size: 20px;\n    }\n  .lift-list {\n    min-width: 200px;\n  }\n    .lift-item {\n      margin-left: auto;\n    margin-right: auto;\n    }\n    .lift-item p {\n      font-size: 17px;\n    }\n  \n    .thank-you-message {\n      min-width: 200px;\n      text-align: center;\n    }\n    \n    }\n\n    @media (max-width: 370px) {\n      .modal button {\n        padding: 5px 10px;\n        font-size: 20px;\n        margin: 3px;\n      }\n    \n      .modal {\n        padding: 10px;\n        min-width: 300px;\n      }\n    \n      .modal-header {\n        font-size: 20px;\n      }\n    .lift-list {\n      min-width: 200px;\n    }\n      .lift-item {\n        margin-left: auto;\n      margin-right: auto;\n      }\n      .lift-item p {\n        font-size: 13px;\n      }\n    \n      .thank-you-message {\n        min-width: 200px;\n        text-align: center;\n      }\n      \n      }\n  \n\n\n\n\n.modal button:hover {\n  background-color: #02669b; /* Darker blue on hover */\n}\n\n/* Add more styles as needed */\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
